// Bilingual translations - Arabic-first
export const translations = {
  ar: {
    // Brand
    brand: 'منصة همم',
    brand_sub: 'للتربية الرياضية المعدّلة',
    tagline: 'أول منصة ذكاء اصطناعي للتربية الرياضية المعدّلة لأصحاب الهمم',
    // Nav
    nav_home: 'الرئيسية',
    nav_curriculum: 'المنهج الدراسي',
    nav_features: 'المميزات',
    nav_about: 'عن المنصة',
    nav_login: 'تسجيل الدخول',
    nav_register: 'إنشاء حساب',
    nav_dashboard: 'لوحة التحكم',
    nav_logout: 'تسجيل الخروج',
    lang_switch: 'English',
    // Landing
    hero_title: 'تربية بدنية شاملة. كرامة لكل المتعلمين.',
    hero_subtitle: 'منصة المنهج المعدّل المدعوم بالذكاء الاصطناعي لأصحاب الهمم – خطط دروس، تقييمات، خطط فردية، وتحليلات أداء، باللغتين العربية والإنجليزية.',
    cta_explore: 'استكشف المنهج',
    cta_start: 'ابدأ مجاناً',
    stats_goals: 'هدف تعليمي',
    stats_disabilities: 'فئة من أصحاب الهمم',
    stats_ages: 'فئة عمرية',
    stats_sports: 'رياضة معدّلة',
    features_title: 'منظومة متكاملة لتعليم شامل',
    features_subtitle: 'كل ما يحتاجه المعلم وولي الأمر والطالب في مكان واحد',
    f_ai_title: 'مولّد دروس بالذكاء الاصطناعي',
    f_ai_desc: 'أنشئ خطط دروس معدّلة مخصصة لكل نوع إعاقة وفئة عمرية بضغطة زر.',
    f_iep_title: 'خطط فردية (IEP)',
    f_iep_desc: 'صياغة خطط تعليمية فردية مرتبطة ببنك أهداف شامل.',
    f_curriculum_title: 'بنك أهداف ضخم',
    f_curriculum_desc: 'أكثر من ٣٠٠٠ هدف تعليمي مفصّل بخطط حصص جاهزة.',
    f_analytics_title: 'لوحة تحليلات وتقارير',
    f_analytics_desc: 'تتبع التقدم، الحضور، والتقييمات لكل طالب.',
    f_assess_title: 'تقييمات وتقارير ذكية',
    f_assess_desc: 'روبركس وتقييمات لياقة، وتقارير آلية بلغتين.',
    f_a11y_title: 'وصول شامل WCAG AAA',
    f_a11y_desc: 'تباين عالي، تحكم بحجم الخط، وملاحة بلوحة المفاتيح.',
    portals_title: 'بوابات متخصصة لكل دور',
    portal_teacher: 'بوابة المعلم',
    portal_teacher_desc: 'تخطيط سنوي وفصلي وأسبوعي، حضور، تقييمات، AI.',
    portal_student: 'بوابة الطالب',
    portal_student_desc: 'دروس، فيديوهات، تحديات، شارات إنجاز.',
    portal_parent: 'بوابة ولي الأمر',
    portal_parent_desc: 'متابعة التقدم، تقارير، أنشطة منزلية، وتواصل.',
    portal_admin: 'لوحة الإدارة',
    portal_admin_desc: 'تحليلات مراكز، معلمين، ومؤشرات أداء.',
    // Auth
    auth_login_title: 'تسجيل الدخول',
    auth_register_title: 'إنشاء حساب جديد',
    field_email: 'البريد الإلكتروني',
    field_password: 'كلمة المرور',
    field_name: 'الاسم الكامل',
    field_role: 'الدور',
    role_teacher: 'معلم',
    role_student: 'طالب',
    role_parent: 'ولي أمر',
    role_admin: 'مدير',
    submit_login: 'دخول',
    submit_register: 'إنشاء الحساب',
    no_account: 'ليس لديك حساب؟',
    have_account: 'لديك حساب؟',
    demo_accounts: 'حسابات تجريبية',
    seed_demo: 'إنشاء حسابات تجريبية',
    // Dashboard
    welcome: 'مرحباً',
    overview: 'نظرة عامة',
    total_students: 'إجمالي الطلاب',
    total_goals: 'الأهداف التعليمية',
    total_ieps: 'الخطط الفردية',
    avg_score: 'متوسط التقييم',
    students_by_disability: 'الطلاب حسب الإعاقة',
    leaderboard: 'لوحة المتصدرين',
    // Curriculum
    curriculum_title: 'مكتبة المنهج المعدّل',
    search_placeholder: 'ابحث في الأهداف، الرياضات، الرموز...',
    filter_disability: 'نوع الإعاقة',
    filter_level: 'مستوى الإعاقة',
    filter_age: 'الفئة العمرية',
    filter_term: 'الفصل الدراسي',
    filter_sport: 'الرياضة/النشاط',
    filter_perf: 'مستوى الأداء',
    clear_filters: 'مسح المرشحات',
    all: 'الكل',
    showing: 'عرض',
    of: 'من',
    next: 'التالي',
    prev: 'السابق',
    view_details: 'عرض التفاصيل',
    main_goal: 'الهدف الرئيسي',
    sub_goal: 'الهدف الفرعي',
    teaching_strategy: 'استراتيجية التعليم',
    tools: 'الأدوات',
    environment: 'البيئة المفضلة',
    full_plan: 'خطة الحصة الكاملة',
    warmup: 'الإحماء',
    main_exercises: 'التمارين الرئيسية',
    cooldown: 'العودة للهدوء',
    adaptations: 'التعديلات',
    // AI Generator
    ai_generator: 'مولّد الدروس بالذكاء الاصطناعي',
    ai_activity_gen: 'مولّد الأنشطة الذكي',
    generate: 'توليد',
    generating: 'جارٍ التوليد...',
    skill_focus: 'مهارة التركيز',
    extra_context: 'سياق إضافي (اختياري)',
    copy: 'نسخ',
    copied: 'تم النسخ',
    translate: 'ترجم',
    // IEP
    iep_builder: 'منشئ الخطة الفردية',
    new_iep: 'خطة جديدة',
    student_name: 'اسم الطالب',
    center_name: 'المركز/المدرسة',
    select_goals: 'اختر الأهداف',
    save: 'حفظ',
    saved: 'تم الحفظ',
    // Accessibility
    a11y_title: 'إعدادات الوصول',
    a11y_font: 'حجم الخط',
    a11y_contrast: 'تباين عالٍ',
    a11y_reset: 'استعادة الافتراضي',
    open_a11y: 'فتح إعدادات الوصول',
    // Misc
    loading: 'جارٍ التحميل...',
    error: 'حدث خطأ',
    no_results: 'لا توجد نتائج',
    points: 'نقطة',
    badges: 'شارات',
    footer_rights: 'جميع الحقوق محفوظة',
    // Plans
    plans_title: 'الخطط (تقويم بسحب وإفلات)',
    plan_new: 'خطة جديدة',
    plan_name: 'اسم الخطة',
    plan_kind: 'النوع',
    plan_annual: 'سنوي',
    plan_term: 'فصلي',
    plan_weekly: 'أسبوعي',
    plan_open: 'فتح',
    plan_delete: 'حذف',
    plan_pool: 'الأهداف المتاحة',
    plan_drop_here: 'اسحب الأهداف هنا',
    plan_save: 'حفظ التخطيط',
    plan_print: 'طباعة',
    // Rubrics
    rubrics_title: 'روبركس التقييم',
    rubric_new: 'روبرك جديد',
    rubric_name: 'اسم الروبرك',
    rubric_description: 'الوصف',
    rubric_criterion: 'معيار',
    rubric_add_criterion: 'إضافة معيار',
    rubric_weight: 'الوزن',
    rubric_levels: 'مستويات الأداء',
    rubric_export: 'تصدير PDF',
    // Messages
    messages_title: 'مركز التواصل',
    messages_to: 'إلى (بريد إلكتروني)',
    messages_placeholder: 'اكتب رسالتك...',
    messages_send: 'إرسال',
    messages_empty: 'لا توجد رسائل بعد. ابدأ المحادثة.',
    messages_open_chat: 'فتح المحادثة',
    // Admin translation panel
    translate_panel: 'ترجمة الأهداف إلى الإنجليزية',
    translate_start: 'بدء الترجمة الدفعية',
    translate_running: 'جارٍ الترجمة...',
    translate_progress: 'التقدم',
    translate_pending: 'متبقي',
    translate_done: 'تمت ترجمته',
    // Generic
    delete: 'حذف',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    // AI Studio
    ai_studio: 'استوديو الذكاء الاصطناعي',
    ai_studio_desc: '١٦ مولّداً ذكياً للمحتوى التعليمي الشامل',
    resource_library: 'مكتبة الموارد',
    image_library: 'مكتبة الصور',
    audio_library: 'مكتبة الأصوات',
    gen_story: 'مولّد القصص',
    gen_flashcards: 'مولّد البطاقات التعليمية',
    gen_lesson: 'مولّد خطط الدروس',
    gen_activity: 'مولّد الأنشطة',
    gen_video: 'مولّد سيناريوهات الفيديو',
    gen_video_sora: 'مولّد الفيديو (Sora 2)',
    gen_visual: 'مولّد العروض البصرية',
    gen_assessment: 'مولّد التقييم والروبركس',
    gen_iep: 'مولّد الخطط الفردية',
    gen_worksheet: 'مولّد ورق العمل',
    gen_family: 'مولّد أنشطة الأسرة',
    gen_certificate: 'مولّد الشهادات',
    gen_quiz: 'مولّد الاختبارات',
    gen_adaptive: 'الأنشطة التكيفية (٥ فئات)',
    gen_coach: 'المدرّب الافتراضي',
    gen_game: 'مولّد الألعاب التعليمية',
    field_topic: 'الموضوع',
    field_count: 'العدد',
    field_voice: 'الصوت',
    field_with_images: 'مع صور',
    field_with_audio: 'مع صوت',
    play: 'تشغيل',
    download: 'تنزيل',
    open_artifact: 'فتح',
  },
  en: {
    brand: 'Himam Platform',
    brand_sub: 'Adapted Physical Education',
    tagline: "The world's first AI-powered Adapted PE platform for People of Determination",
    nav_home: 'Home',
    nav_curriculum: 'Curriculum',
    nav_features: 'Features',
    nav_about: 'About',
    nav_login: 'Login',
    nav_register: 'Sign Up',
    nav_dashboard: 'Dashboard',
    nav_logout: 'Logout',
    lang_switch: 'العربية',
    hero_title: 'Inclusive Physical Education. Dignity for every learner.',
    hero_subtitle: 'AI-powered adapted curriculum platform for People of Determination — lesson plans, assessments, IEPs, and performance analytics, in Arabic & English.',
    cta_explore: 'Explore Curriculum',
    cta_start: 'Get Started Free',
    stats_goals: 'Learning Goals',
    stats_disabilities: 'Disability Categories',
    stats_ages: 'Age Groups',
    stats_sports: 'Adapted Sports',
    features_title: 'An Integrated Ecosystem for Inclusive Education',
    features_subtitle: 'Everything teachers, parents, and students need — in one place',
    f_ai_title: 'AI Lesson Generator',
    f_ai_desc: 'Create personalized adapted lesson plans for any disability profile in seconds.',
    f_iep_title: 'Individual Education Plans',
    f_iep_desc: 'Build IEPs linked to a comprehensive goal bank.',
    f_curriculum_title: 'Massive Goal Bank',
    f_curriculum_desc: 'Over 3,000 detailed learning goals with ready-made session plans.',
    f_analytics_title: 'Analytics & Reports',
    f_analytics_desc: 'Track progress, attendance, and assessments per student.',
    f_assess_title: 'Smart Assessments',
    f_assess_desc: 'Rubrics, fitness evaluations, and automated bilingual reports.',
    f_a11y_title: 'WCAG AAA Accessibility',
    f_a11y_desc: 'High contrast, font controls, and full keyboard navigation.',
    portals_title: 'Dedicated Portals for Every Role',
    portal_teacher: 'Teacher Portal',
    portal_teacher_desc: 'Annual/term/weekly planning, attendance, assessments, AI tools.',
    portal_student: 'Student Portal',
    portal_student_desc: 'Lessons, videos, challenges, achievement badges.',
    portal_parent: 'Parent Portal',
    portal_parent_desc: 'Track progress, reports, home activities & communication.',
    portal_admin: 'Admin Dashboard',
    portal_admin_desc: 'Analytics for centers, teachers, and KPIs.',
    auth_login_title: 'Login',
    auth_register_title: 'Create a new account',
    field_email: 'Email',
    field_password: 'Password',
    field_name: 'Full Name',
    field_role: 'Role',
    role_teacher: 'Teacher',
    role_student: 'Student',
    role_parent: 'Parent',
    role_admin: 'Admin',
    submit_login: 'Login',
    submit_register: 'Create Account',
    no_account: "Don't have an account?",
    have_account: 'Already have an account?',
    demo_accounts: 'Demo accounts',
    seed_demo: 'Create demo accounts',
    welcome: 'Welcome',
    overview: 'Overview',
    total_students: 'Total Students',
    total_goals: 'Learning Goals',
    total_ieps: 'IEPs',
    avg_score: 'Avg Assessment',
    students_by_disability: 'Students by Disability',
    leaderboard: 'Leaderboard',
    curriculum_title: 'Adapted Curriculum Library',
    search_placeholder: 'Search goals, sports, codes...',
    filter_disability: 'Disability',
    filter_level: 'Severity',
    filter_age: 'Age Group',
    filter_term: 'Term',
    filter_sport: 'Sport/Activity',
    filter_perf: 'Performance Level',
    clear_filters: 'Clear filters',
    all: 'All',
    showing: 'Showing',
    of: 'of',
    next: 'Next',
    prev: 'Previous',
    view_details: 'View details',
    main_goal: 'Main Goal',
    sub_goal: 'Sub-goal',
    teaching_strategy: 'Teaching Strategy',
    tools: 'Tools',
    environment: 'Preferred Environment',
    full_plan: 'Full Session Plan',
    warmup: 'Warm-up',
    main_exercises: 'Main Exercises',
    cooldown: 'Cool-down',
    adaptations: 'Adaptations',
    ai_generator: 'AI Lesson Generator',
    ai_activity_gen: 'AI Activity Generator',
    generate: 'Generate',
    generating: 'Generating...',
    skill_focus: 'Skill focus',
    extra_context: 'Extra context (optional)',
    copy: 'Copy',
    copied: 'Copied',
    translate: 'Translate',
    iep_builder: 'IEP Builder',
    new_iep: 'New IEP',
    student_name: 'Student name',
    center_name: 'Center/School',
    select_goals: 'Select goals',
    save: 'Save',
    saved: 'Saved',
    a11y_title: 'Accessibility',
    a11y_font: 'Font size',
    a11y_contrast: 'High contrast',
    a11y_reset: 'Reset',
    open_a11y: 'Open accessibility settings',
    loading: 'Loading...',
    error: 'Error',
    no_results: 'No results',
    points: 'pts',
    badges: 'badges',
    footer_rights: 'All rights reserved',
    plans_title: 'Plans (drag & drop calendar)',
    plan_new: 'New plan',
    plan_name: 'Plan name',
    plan_kind: 'Type',
    plan_annual: 'Annual',
    plan_term: 'Term',
    plan_weekly: 'Weekly',
    plan_open: 'Open',
    plan_delete: 'Delete',
    plan_pool: 'Available goals',
    plan_drop_here: 'Drop goals here',
    plan_save: 'Save plan',
    plan_print: 'Print',
    rubrics_title: 'Assessment Rubrics',
    rubric_new: 'New rubric',
    rubric_name: 'Rubric name',
    rubric_description: 'Description',
    rubric_criterion: 'Criterion',
    rubric_add_criterion: 'Add criterion',
    rubric_weight: 'Weight',
    rubric_levels: 'Performance levels',
    rubric_export: 'Export PDF',
    messages_title: 'Communication Center',
    messages_to: 'To (email)',
    messages_placeholder: 'Type your message...',
    messages_send: 'Send',
    messages_empty: 'No messages yet. Start the conversation.',
    messages_open_chat: 'Open chat',
    translate_panel: 'Translate goals to English',
    translate_start: 'Start batch translation',
    translate_running: 'Translating...',
    translate_progress: 'Progress',
    translate_pending: 'Pending',
    translate_done: 'Translated',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    ai_studio: 'AI Studio',
    ai_studio_desc: '16 intelligent generators for inclusive educational content',
    resource_library: 'Resource Library',
    image_library: 'Image Library',
    audio_library: 'Audio Library',
    gen_story: 'Story Generator',
    gen_flashcards: 'Flashcards Generator',
    gen_lesson: 'Lesson Plan Generator',
    gen_activity: 'Activity Generator',
    gen_video: 'Video Storyboard Generator',
    gen_video_sora: 'AI Video (Sora 2)',
    gen_visual: 'Visual Demo Generator',
    gen_assessment: 'Assessment & Rubric Generator',
    gen_iep: 'IEP Generator',
    gen_worksheet: 'Worksheet Generator',
    gen_family: 'Family Activities Generator',
    gen_certificate: 'Certificate Generator',
    gen_quiz: 'Quiz Generator',
    gen_adaptive: 'Adaptive Activities (5 categories)',
    gen_coach: 'AI Avatar Coach',
    gen_game: 'Educational Game Generator',
    field_topic: 'Topic',
    field_count: 'Count',
    field_voice: 'Voice',
    field_with_images: 'With images',
    field_with_audio: 'With audio',
    play: 'Play',
    download: 'Download',
    open_artifact: 'Open',
  },
};

export function getDir(lang) { return lang === 'ar' ? 'rtl' : 'ltr'; }
